import { __ } from "@wordpress/i18n";


export const paginationTypes = {
	none: {
		label: __("None", "woocommerce-products-slider"),
		value: "none"
	},
	normal: {
		label: __("Normal Pagination",
			"woocommerce-products-slider"), value: "normal"
	},
	ajax: {
		label: __("Ajax Pagination", "woocommerce-products-slider"),
		value: "ajax",
		isPro: true,
	},
	next_previous: {
		label: __("Next-Previous", "woocommerce-products-slider"),
		value: "next_previous",
		isPro: true,
	},
	loadmore: {
		label: __("Load More", "woocommerce-products-slider"),
		value: "loadmore",
		isPro: true,
	},
	infinite: {
		label: __("Infinite Load", "woocommerce-products-slider"),
		value: "infinite",
		isPro: true,
	},
	// filterable: {
	// 	label: __("Filterable", "woocommerce-products-slider"),
	// 	value: "filterable"
	// },
}